import React from 'react';
import { Counter } from './features/counter/Counter';
import './App.css';
import { PartyEvents } from './features/partyEvents/PartyEvents';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { EditPartyEvent } from './features/partyEvents/EditPartyEvent';
import { CurrentPartyEvent } from './features/currentPartyEvent/CurrentPartyEvent';
import { Header } from './Header';
import { LoginPanel } from './features/auth/LoginPanel';
import { EditEventTask } from './features/currentEventTask/EditEventTask'
import { Menu } from './features/menu/Menu';
import { CurrentEventUsers } from './features/currentEventUsers/CurrentEventUsers';
import { AddEventUser} from './features/addEventUser/AddEventUser'
import { Invitation } from './features/invitation/Invitation'
import { Privacy } from './features/compliance/Privacy';
import { TermsAndConditions } from './features/compliance/TandCs';
import { MessageBox } from './features/messageBoxes/OkCancelMessageBox';
import { Information } from './features/compliance/Information';
import { Notifications } from './features/notifications/Notifications';
import { NotificationPanel } from './features/notifications/NotificationPanel';
import { Welcome } from './features/wizard/Welcome';
import { CreateName } from './features/wizard/CreateName';
import { CreateDate } from './features/wizard/CreateDate';
import { Location } from './features/wizard/Location';
import { CreateEndTime } from './features/wizard/CreateEndTime';
import {  NameEventTask, } from './features/eventTaskWizard/NameEventTask';
import { ChooseEventTask } from './features/eventTaskWizard/ChooseEventTask';
import { Email } from './features/eventTaskWizard/Email';
import { Notes } from './features/eventTaskWizard/Notes';
import { App as CapApp } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { callbackUri } from './AppSettings';
import { FeedBack } from './features/feedback/FeedBack';
import { EditEventUser } from './features/addEventUser/EditEventUser';
import { DataDelete } from './features/compliance/DataDelete';
import { Merchandise } from './features/compliance/Merchandise';
import { AccountDetails } from './features/compliance/AccountDetails';
import { BackButton } from './features/menu/BackButton';

document.title = "PartyPlanner";

function App() {
  const { handleRedirectCallback } = useAuth0();

  useEffect(() => {
    CapApp.addListener("appUrlOpen", async ({ url }) => {
      if (url.startsWith(callbackUri)) {
        if (
          url.includes("state") &&
          (url.includes("code") || url.includes("error"))
        ) {
          await handleRedirectCallback(url);
        }

        await Browser.close();
      }
    });
  }, [handleRedirectCallback]);
  return (
    <div className='App'>
      <BrowserRouter>
      <Header>
        <Menu />
        <NotificationPanel />
        <LoginPanel />
      </Header>
      {/* <div className="bannerContainer">
          <div>
              <h2>PartyPlanner.</h2>
                  <h4>Organise, invite and celebrate in style.</h4>
          </div>
          <div className="bannerButton">
              <BackButton/>
          </div>
      </div> */}
          <Routes>
            <Route path="/" element={<PartyEvents />} />
            <Route path="/editPartyEvent" element={<EditPartyEvent />} />
            <Route path="/currentPartyEvent" element={<CurrentPartyEvent />} />
            <Route path="/editEventTask" element={<EditEventTask />} />
            <Route path="/currentEventUsers" element={<CurrentEventUsers />} />
            <Route path="/AddEventUser" element={<AddEventUser />} />
            <Route path="/invitation/:eventId" element={<Invitation />} />
            <Route path='counter' element={<Counter />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path='/TermsAndConditions' element={<TermsAndConditions />} />
            <Route path='/MessageBox' element={<MessageBox/>} />
            <Route path='/Information' element={<Information/>} />
            <Route path='/Notifications' element={<Notifications/>} />
            <Route path='/Welcome' element={<Welcome/>} />
            <Route path='/CreateName' element={<CreateName/>} />
            <Route path='/CreateDate' element={<CreateDate/>} />
            <Route path='/Location' element={<Location/>} />
            <Route path='/CreateEndTime' element={<CreateEndTime/>} />
            <Route path='/NameEventTask' element={<NameEventTask/>} />
            <Route path='/ChooseEventTask' element={<ChooseEventTask/>} />
            <Route path='/Email' element={<Email/>} />
            <Route path='/Notes' element={<Notes/>} />
            <Route path='/Feedback' element={<FeedBack/>} />
            <Route path='/EditEventUser' element={<EditEventUser/>}/>
            <Route path='/DataDelete' element={<DataDelete/>}/>
            <Route path='/Merchandise' element={<Merchandise/>}/>
            <Route path='/AccountDetails' element={<AccountDetails/>}/>
          </Routes>
        </BrowserRouter>
      
    </div>
  );
}

export default App;
